'use client';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {NamedFaIcon} from '../icon';
import {Typography} from '../primitives';

export interface AmenityChipProps {
  icon: string;
  label: string;
}

const Root = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.colors.icon.primary.default,
  backgroundColor: theme.palette.colors.surface.neutral.subtle,
  borderRadius: theme.radii.full,
  paddingBlock: theme.spacing(1.5),
  paddingInlineStart: 15,
  paddingInlineEnd: 17,
}));

export function AmenityChip({icon, label}: AmenityChipProps) {
  return (
    <Root>
      <NamedFaIcon name={icon} />
      <Typography size="body-2" weight="regular" family="primary" sx={{color: theme => theme.palette.colors.text.neutral.default}}>
        {label}
      </Typography>
    </Root>
  );
}

AmenityChip.displayName = 'AmenityChip';
